import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const pains = ['Analizar cada mensaje antes de enviarlo.', 'Esperar horas para que te respondan.', "Sentir que otros hombres 'menos buenos' sí tienen éxito.", "Escuchar 'te veo como amigo'.", 'No saber cuándo avanzar y cuándo frenar.', 'Sentir que el problema sos vos.'];
  return <section className="py-20 px-4 bg-brand-black" data-id="element-99">
      <div className="container mx-auto max-w-3xl" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-101">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-102">
            Seamos honestos. <br data-id="element-103" />
            <span className="text-gray-500" data-id="element-104">Estás cansado de:</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-105">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start p-4 bg-brand-dark border-l-4 border-brand-red rounded-r-lg" data-id="element-106">
              <XCircle className="w-6 h-6 text-brand-red mr-4 flex-shrink-0 mt-1" data-id="element-107" />
              <p className="text-lg text-gray-300 font-medium" data-id="element-108">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-12 text-center" data-id="element-109">
          <p className="text-2xl font-heading uppercase text-white" data-id="element-110">
            Pero no lo sos.
          </p>
        </motion.div>
      </div>
    </section>;
}